module.exports = __webpack_public_path__ + "static/img/logoUNIWhite.76befd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoUNIWhite.png
// module id = FJcv
// module chunks = 41